module.exports = __webpack_public_path__ + "media/images/athletes/4322-dea7846c135428c80e69f0308b126459.png";